import { atom, useSetAtom } from 'jotai'
import { createScope } from '~/lib/jotai'
import type { RestaurantSummaryType } from './getRestaurantSummary.graphql'

export const scope = createScope('guide')

const _restaurant$ = scope.atom<RestaurantSummaryType>(
  undefined as any as RestaurantSummaryType,
  'restaurant$'
)

export const restaurant$ = atom((get) => get(_restaurant$))

export function useSetRestaurant() {
  return useSetAtom(_restaurant$)
}

export const restaurantId$ = atom((get) => get(restaurant$)?.restaurantId)
